module.exports = __webpack_public_path__ + "img/NSM_Mockups.ccfbfd32.png";